import { useCallback } from "react";
import { useServices } from "contexts/ServiceContext";
import { useQuery } from "react-query";
import { INotification } from "@tiendeo/auth/dist/AuthApi/Controllers/Notifications/Entities/INotification";
import { EnumCookiesAuth } from "@tiendeo/auth/dist";
import { UNAUTHORIZED_ERROR_MESSSAGE } from "utils/errorMessages";
import { NOTIFICATION_QUERY_TYPE } from "./queryKeys";

const useNotificationsQuery = () => {
    const services = useServices();

    const getNotifications = useCallback(async () => {
        try {
            return await services.AuthApiClient.Notifications.Get();
        } catch (error) {
            if (error.response.status === 401) {
                services.CookiesClient.Delete(EnumCookiesAuth.ACCESS_TOKEN);
                services.CookiesClient.Delete(EnumCookiesAuth.END_USER_ID);
                services.CookiesClient.Delete(EnumCookiesAuth.EXPIRATION_ACCESS_TOKEN);
                throw new Error(UNAUTHORIZED_ERROR_MESSSAGE);
            }
        }
    }, []);

    return useQuery<INotification[], Error>(NOTIFICATION_QUERY_TYPE, getNotifications, {
        retry: (_failureCount, error: Error) => error.message !== UNAUTHORIZED_ERROR_MESSSAGE,
    });
};

export default useNotificationsQuery;
